import { useEffect, useState } from 'react';
import useAuthStore from '@/store/useAuthStore';
import { fetchUserApi } from '@/api/userApi'; // Necesitamos la función que busca el usuario

/**
 * Este hook se ejecuta una vez al inicio de la app para validar la sesión persistente.
 */
export const useSessionValidator = () => {
  const [isValidating, setIsValidating] = useState(true);
  const { token, user, clearAuthState } = useAuthStore();

  useEffect(() => {
    const validateSession = async () => {
      // Validate user session if we have a token
      if (token && user) {
        try {
          // Intentamos obtener los datos del usuario. Esta es la "validación".
          await fetchUserApi(); 
          // Si la llamada tiene éxito, no hacemos nada. El token es válido y la
          // lógica de useAuth se encargará de poblar el estado.
          //console.log("✅ Sesión persistente validada correctamente.");
        } catch (error) {
          // Si la API devuelve un error (ej. 401 Unauthorized), el token es inválido.
          console.warn("❌ Token persistente inválido. Limpiando sesión. Error:", error);
          clearAuthState(); // Limpiamos el estado del store y localStorage.
        }
      }
      setIsValidating(false);
    };

    validateSession();
  }, []); // El array vacío asegura que este efecto se ejecute UNA SOLA VEZ.

  return isValidating;
};